import { Star } from 'lucide-react';
import type { PublicRating } from '../ratings.ts';

// Note publique : jamais de note brute sur peu d'avis (« Nouveau »), seulement les tags positifs récurrents.
export function RatingLine({ rating }: { rating?: PublicRating }) {
  if (!rating) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        {rating.isNew ? (
          <span className="badge badge-neutral">Nouveau{rating.count > 0 ? ` · ${rating.count} avis` : ''}</span>
        ) : (
          <>
            <Star size={13} color="var(--accent)" fill="var(--accent)" />
            <span style={{ fontSize: 12.5, fontWeight: 700 }}>{rating.score?.toFixed(1)}</span>
            <span style={{ fontSize: 12.5, color: 'var(--text-tertiary)' }}>· {rating.count} avis</span>
          </>
        )}
      </div>
      {rating.topTags.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {rating.topTags.map((t) => <span key={t.code} className="badge badge-available">{t.emoji} {t.label} · {t.count}</span>)}
        </div>
      )}
    </div>
  );
}
